import React from 'react';
import { Link } from 'react-router-dom';

const Header = ({ user }) => {
  return (
    <header className="bg-[#FF0000] text-white py-4 px-6 shadow-lg">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        {user && <Link to="/" className="text-xl font-bold hover:text-yellow-300 transition-colors duration-200">PokéLens</Link>}
        <nav>
          {user && (
            <div className="space-x-6">
              <Link to="/hello" className="hover:text-yellow-300 transition-colors duration-200 font-medium">Hello</Link>
              <Link to="/search" className="hover:text-yellow-300 transition-colors duration-200 font-medium">Search</Link>
              <Link to="/scan" className="hover:text-yellow-300 transition-colors duration-200 font-medium bg-[#3B4CCA] px-4 py-2 rounded-full">Scan</Link>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;